/*-- import aliases -----------
'!/...' -> project root
'~/...' -> js folder root
-----------------------------*/
import { setup } from "~/core";
setup();

import "~/global/_body";
import "~/global/_header";
import "~/global/_searchbar";
import "~/global/_footer";
import "~/global/_svg";

import "~/components/_accordion";
import "~/components/_alert";
import "~/components/_anchors";
import "~/components/_appBanner";
import "~/components/_backToTop";
import "~/components/_cardSlider";
import "~/components/_cookies";
import "~/components/_copy";
import "~/components/_exitModal";
import "~/components/_faq";
import "~/components/_fccuMedia";
import "~/components/_forms";
import "~/components/_heroSlider";
import "~/components/_modal";
import "~/components/_sitemap";
import "~/components/_table";
import "~/components/_testimonialCard";
import "~/components/_video";